/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable-next-line no-shadow */
import React, { useState, useCallback, FormEvent, useEffect } from 'react';
import _ from 'lodash';
import { FiSearch } from 'react-icons/fi';
import { ComponentSelector } from 'components/ComponentSelector';
import NcmChatSidebar from 'components/NcmChatSidebar';
import { Title, Form, Errors, SearchRow, NcmButton } from './styles';
import Header from '../../components/Header';

// Chat do NCM ainda em desenvolvimento: só aparece com REACT_APP_NCM_CHAT_ENABLED=true no build.
const ncmChatEnabled = process.env.REACT_APP_NCM_CHAT_ENABLED === 'true';

const Dashboard: React.FC = () => {
  const [query, setQuery] = useState(() => {
    const storageQuery = localStorage.getItem(
      '@warehouse_explorer:lastQueryResults',
    );
    if (!storageQuery) {
      return '';
    }
    return JSON.parse(storageQuery);
  });
  const [inputError, setInputError] = useState('');
  const [ncmSidebarOpen, setNcmSidebarOpen] = useState(false);
  const [debouncedQuery, setDebouncedQuery] = useState(() => {
    const storageQuery = localStorage.getItem(
      '@warehouse_explorer:lastQueryResults',
    );
    if (!storageQuery) {
      return 'nonExistentItem';
    }
    return JSON.parse(storageQuery);
  });
  const debounceQuery = useCallback(_.debounce(setDebouncedQuery, 500), []);

  useEffect(() => {
    localStorage.setItem(
      '@warehouse_explorer:lastQueryResults',
      JSON.stringify(debouncedQuery),
    );
  }, [debouncedQuery]);

  async function handleSearchItem(
    event: FormEvent<HTMLFormElement>,
  ): Promise<void> {
    event.preventDefault();
    setInputError('');
    const invalidSearchTerm = /^\s{1,}/.test(query);
    if (!query || invalidSearchTerm) {
      setInputError('Digite um termo de busca válido');
      return;
    }
    try {
      debounceQuery(query);
    } catch (err) {
      setInputError('Erro na busca por esse item');
    }
  }

  return (
    <>
      <Header />
      <Title>Verifique o item em nosso estoque.</Title>
      <SearchRow>
        <Form hasError={!!inputError} onSubmit={handleSearchItem}>
          <input
            value={query}
            onChange={event => {
              setQuery(event.target.value);
            }}
            placeholder="Digite seu termo de busca"
          />
          <button type="submit">Pesquisar</button>
        </Form>
        {ncmChatEnabled && (
          <NcmButton type="button" onClick={() => setNcmSidebarOpen(true)}>
            <FiSearch />
            Descobrir NCM
          </NcmButton>
        )}
      </SearchRow>
      {inputError && <Errors>{inputError}</Errors>}
      <ComponentSelector inputString={debouncedQuery} />
      {ncmChatEnabled && (
        <NcmChatSidebar
          isOpen={ncmSidebarOpen}
          onClose={() => setNcmSidebarOpen(false)}
        />
      )}
    </>
  );
};
export default Dashboard;
